
import { useState } from "react";
import { useDebounce } from "@/hooks/useDebounce";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface ProductSearchResult {
  product_naam: string;
  product_id: string;
  bc: string;
  eenheid: string; // Added eenheid field
}

export function useProductSearch() {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState<ProductSearchResult[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const debouncedSearch = useDebounce(searchTerm, 300);

  const searchProducts = async (term: string) => {
    if (!term || term.length < 2) {
      setResults([]);
      return;
    }

    setIsLoading(true);

    try {
      console.log('Searching for products in voorraad_live2 table:', term);
      
      // Query the voorraad_live2 table directly instead of using RPC
      const { data, error } = await supabase
        .from('voorraad_live2')
        .select('product_naam, product_id, bc, eenheid') // Added eenheid to selected fields
        .or(`product_naam.ilike.%${term}%,product_id.ilike.%${term}%,bc.ilike.%${term}%`)
        .limit(10);

      if (error) {
        console.error('Error searching products:', error);
        throw error;
      }

      console.log('Search results from voorraad_live2 table:', data);
      
      if (!data || data.length === 0) {
        setResults([]);
        return;
      }

      // Format results to match ProductSearchResult interface
      const formattedResults: ProductSearchResult[] = data.map(item => ({
        product_naam: String(item.product_naam || ''),
        product_id: String(item.product_id || ''),
        bc: String(item.bc || ''),
        eenheid: String(item.eenheid || '') // Added eenheid to results
      }));

      console.log('Formatted search results:', formattedResults);
      setResults(formattedResults);
    } catch (error) {
      console.error('Error in product search:', error);
      toast.error('Er is een fout opgetreden bij het zoeken naar producten');
      setResults([]);
    } finally {
      setIsLoading(false);
    }
  };

  return { 
    searchTerm, 
    setSearchTerm, 
    results, 
    isLoading, 
    searchProducts 
  };
}
